
import type { PropOptions } from 'vue';
import Vue from 'vue';
import CloseIcon from '~/assets/svg/close.vue.svg';

export const variants = ['plain', 'info', 'warning', 'error'];
export default Vue.extend({
  name: 'BravadoCallout',
  components: {
    CloseIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    } as PropOptions<string>,
    message: {
      type: String,
      default: '',
    } as PropOptions<string>,
    width: {
      type: String,
      default: 'auto',
    } as PropOptions<string>,
    hasCloseButton: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    variant: {
      type: String,
      default: 'info',
      validator: (value: string) => variants.includes(value),
    } as PropOptions<'plain' | 'info' | 'warning' | 'error'>,
    bgColor: {
      type: String,
      default: '',
    } as PropOptions<string>,
  },
  computed: {
    rootClass() {
      return {
        'bravado-callout': true,
        [`bravado-callout--${this.variant}`]: true,
      };
    },
    rootStyle() {
      return {
        backgroundColor: this.bgColor,
        width: this.width,
      };
    },
  },
});
